import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type FirebaseState from '../types/FirebaseState';
import type FirebaseAccountEntity from '../entities/FirebaseAccountEntity';

const initialState: FirebaseState = {
    user: null,
};

export const FirebaseSliceName = 'firebase';
export const FirebaseSlice = createSlice({
    name: FirebaseSliceName,
    initialState,
    reducers: {
        canAccessInternalWebsite: (state) => {
            if (state.user) {
                state.user.isCanAccessInternalWebsite = true;
            }
        },
        canNotAccessInternalWebsite: (state) => {
            if (state.user) {
                state.user.isCanAccessInternalWebsite = false;
            }
        },
        logout: (state) => {
            state.user = null;
        },
        setUser: (state, action: PayloadAction<FirebaseAccountEntity | null>) => {
            state.user = action.payload;
        },
    },
});

export const { canAccessInternalWebsite, canNotAccessInternalWebsite, logout, setUser } = FirebaseSlice.actions;

export const FirebaseReducer = FirebaseSlice.reducer;
